import emojiJson from '../json/emoji.json'
export  default  emojiJson;
// export default emojiXml.PopoEmoticons.Catalog[0].Emoticon



// WEBPACK FOOTER //
// ./src/common/js/emoji-config-list.js